import React, { cloneElement, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { loadQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import useAmplitude from "../../../../hooks/useAmplitude";
import { mathpidLogAPICall } from "../../../../redux/logData";
import { URL } from "../../../../constant";

const Closer = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { setAmplitudeLog } = useAmplitude();
  const questionData = useSelector(
    (state) => state.amplitudeLogData.question_data
  );
  const answeringQuestions = useSelector((state) => state.answeringQuestions);
  const loadQuestion = (payload) => {
    dispatch(loadQuestionAction(payload));
  };

  const close = () => {
    loadQuestion({
      progressCode: TYPE.ANSWERING_QUESTIONS_PROGRESS.USER_CLOSE,
    });

    setAmplitudeLog({
      eventName: {
        name: "학습문항풀이 이탈",
        event: {
          학습유형: "",
          소주제이름: questionData.stgNm,
          커리큘럼그룹: questionData.thmaNm,
          커리큘럼명: questionData.stepNm,
          소주제코드: questionData.stgCd,
          문항코드: questionData.qstCd,
          문항노출순서: `${answeringQuestions.answeringCount}/${questionData.totQstCt}`,
        },
      },
    });

    // 개념확인 팝업으로 페이지이동 분기처리
    // if (answeringQuestions.learningType === TYPE.LEARNING.TOPIC) {
    //   console.log("***** 문제 푸는 페이지 -> 주제학습 페이지");
    //   history.push(URL.TOPIC_LEARNING);
    // } else {
      console.log("***** 문제 푸는 페이지에서 뒤로가기");
      history.goBack();
    // }
  };

  return cloneElement(props.children || <Fragment />, { onClose: close });
};

export default Closer;
